import React from 'react'

export type UserAvatarSize = string | number | { width?: string | number; height?: string | number }

interface IUserMethodsProps {
    minimize: boolean
    size: UserAvatarSize
}

const UserMethods = (p_: IUserMethodsProps) => {
    function getAvatarSizes(): React.CSSProperties
    function getAvatarSizes(mode: 'x'): React.CSSProperties
    function getAvatarSizes(mode: true): string | number | undefined
    function getAvatarSizes(mode?: true | 'x'): React.CSSProperties | string | number | undefined {
        if (mode === 'x') {
            return { width: 40, height: 40 }
        }

        if (p_.minimize) {
            return mode ? 40 : { width: 40, height: 40 }
        }

        if (typeof p_.size !== 'object') {
            return mode ? p_.size : { width: p_.size, height: p_.size }
        }

        if (mode) {
            return p_.size.width || p_.size.height
        }

        return p_.size
    }

    return {
        getAvatarSizes,
    }
}

export default UserMethods
